import React from "react";
import CSVIconPurple2 from "images/file-csv-light-purple.svg";
import { AttachContextButton } from "components/NewChat/ContextSelectionPanel";
const AttachFile = ({ onComplete }) => {
    return (React.createElement(AttachContextButton, { onComplete: onComplete, type: "secondary", style: { marginRight: "12px" } },
        "Attach File",
        React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("img", { src: CSVIconPurple2 })))));
};
export default AttachFile;
